var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('JoinBanner'),_c('JoinHeader'),_c('JoinInfos'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }